import { Routes } from '@angular/router';
import {CrazyComponent} from './crazy.component';

export const routes: Routes = [
    { path: '', component: CrazyComponent }
];
